<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.additional.informations.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.payment.method.label.decription')}}
                                </p>
                                <h4 style="color:red" >
                                    {{$t('string.msg.payment.method.label.decription.alert')}}
                                </h4>
                                <h6 style="color:red" >
                                    {{$t('string.msg.payment.method.label.decription.detalis')}}
                                </h6>

                                <form>
                                 
                                     <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.type.payment.label')}}
                                            </label>
                                            
                                             <select disabled id="banks" v-model="data.paymentType" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <!-- <option value="CREDIT_CARD">{{$t('string.msg.company.type.payment.card')}}</option> -->
                                                <option value="BANK_SLIP">{{$t('string.msg.company.type.payment.bank.split')}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="data.paymentType == 'CREDIT_CARD'" class="form-row">

                                      <div class="form-group col-md-3"></div>
                                      <div class="form-group col-md-5">
                                    
                                        <div id='payment' class='payment'>
                                          <div class='credit-card'>
                                            <div class='credit-card-content c-card'>
                                              <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <h5 class="c-card"  style="margin-top:10px">{{$t('str.order.company.payment.cardnumber.label')}}</h5>
                                                    <h6 class="c-card" id='label-cardnumber'>{{data.number}}</h6>
                                                </div>
                                              </div>
                                              <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <h5 class="c-card">{{$t('str.order.company.payment.name.label')}}</h5>
                                                    <h6 class="c-card" id='label-cardnumber'>{{data.name}}</h6>
                                                </div>
                                              </div>
                                              <div class="form-row">
                                                <div class="form-group col-md-6">
                                                  <h5 class="c-card">{{$t('str.order.company.payment.expiration.label')}}</h5>
                                                  <h6 class="c-card" id='label-cardexpiration'>{{data.dueDate}}</h6>
                                                </div>
                                                <div class="form-group col-md-6">
                                                  <h5 class="c-card">CVC</h5>
                                                  <h6 class="c-card" id='label-cardexpiration'>{{data.cvv}}</h6>
                                                </div>
                                              </div>
                                            </div>
                                            <div class='wave'></div>
                                          </div>
                                          <div class='credit-card-form'>

                                              <p class='field space'>
                                                <span><i class="far fa-credit-card" style="color:#D3D3D3"></i></span>
                                                <input class="c-card" type='text' v-model="data.number" v-mask="'#### #### #### ####'" placeholder='1234 5678 9123 4567' id="cardnumber" pattern='\d*' ti tle='Card Number' />
                                              </p>

                                              <p class='field space'>
                                                <span><i class="far fa-address-card" style="color:#D3D3D3"></i></span>
                                                <input  class="c-card" type='text'  v-model="data.name"  placeholder="Nome" id="cardName" title='Nome' />
                                              </p>

                                              <p class='field space'>
                                                <span><i class="fas fa-credit-card" style="color:#D3D3D3"></i></span>
                                                <input class="c-card" type='text'  v-model="data.dueDate" v-mask="'##/##'" placeholder="MM / YY" id="cardexpiration" pattern="\d*" title='Card Expiration Date' />
                                              </p>
                                              
                                              <p class='field space' >
                                                <span><i class="fas fa-shield-alt" style="color:#D3D3D3"></i></span>
                                                <input class="c-card" type='text' v-model="data.cvv" v-mask="'###'"  id='cardcvc' name='cardcvc' placeholder="123" pattern="\d*" title='CVC Code' />
                                              </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="form-group col-md-4"></div>
                                      <div class="form-row">
                                      <div class="form-group col-md-6">
                                          <label for="inputAddress" class="col-form-label">
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.document.label')}}
                                          </label>
                                            <select id="documentType" v-model="data.documentType" class="form-control">
                                              <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                              <option value="CNPJ">{{$t('CNPJ')}}</option>
                                              <option value="CPF">{{$t('string.msg.company.document.cpf')}}</option>
                                          </select>
                                      </div>
                                    </div>

                                    <div v-if="data.documentType != null" class="form-row">

                                      <div class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{$t('string.msg.company.label.name')}}
                                        </label>
                                        <input type="tel" v-model="data.name" class="form-control" :placeholder="$t('string.msg.company.placeholder.name')">
                                      </div>

                                      <div v-if="data.documentType =='CNPJ'" class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                          <code class="highlighter-rouge">*</code>
                                          {{$t('string.msg.company.label.fantasyName')}}
                                        </label>
                                        <input type="tel" v-model="data.fantasyName" class="form-control" :placeholder="$t('string.msg.company.placeholder.fantasyName')">
                                        <span class="col-form-label cursor-pointer" @click="getFantasyName">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {{$t('string.msg.use.company.data.my.self.fantasyName.label')}}
                                        </span>
                                      </div>

                                        <div v-if="data.documentType =='CNPJ'" class="form-group col-md-6">
                                          <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{$t('string.msg.company.label.document')}}
                                          </label>
                                          <input type="tel" v-mask="'##.###.###/####-##'"  v-model="data.document" class="form-control" :placeholder="$t('string.msg.company.placeholder.document')">
                                          <span class="col-form-label cursor-pointer" @click="getCNPJ">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            {{$t('string.msg.use.company.data.my.self.cnpj.label')}}
                                          </span>
                                      </div>

                                      <div v-if="data.documentType == 'CPF' && data.documentType != null" class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{$t('string.msg.company.document.cpf')}}
                                        </label>
                                        <input type="tel" v-mask="'###.###.###-##'"  v-model="data.document" class="form-control" :placeholder="$t('string.msg.company.placeholder.document.cpf')">
                                      </div>

                                    </div>

                                    <div class="form-row">
                                      <div class="form-group col-md-4" >
                                          <h4 class="col-form-label">
                                              {{$t('string.msg.address.company.payment.label')}}
                                          </h4>
                                      </div>
                                    </div>
                                    <div class="form-row ">
                                      <div class="form-group col-sm-2">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.cep')}}
                                          </label>
                                          <input @blur="loadInfosByCEP" v-mask="'#####-###'" v-model="address.cep" type="tel" class="form-control" :placeholder="$t('string.msg.company.label.cep')" />
                                            <span class="col-form-label cursor-pointer" @click="getAddress">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                {{$t('string.msg.use.company.data.my.self.address.label')}}
                                          </span>
                                      </div>
                                  </div>
                                  <div v-if="address.cep && address.cep.length == 9" class="form-row ">
                                      <div class="form-group col-sm-2">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.state')}}    
                                          </label>
                                          <select v-model="address.state" class="form-control select2">
                                              <option :value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                              <option value="AC">AC</option>
                                              <option value="AL">AL</option>
                                              <option value="AP">AP</option>
                                              <option value="AM">AM</option>
                                              <option value="BA">BA</option>
                                              <option value="CE">CE</option>
                                              <option value="DF">DF</option>
                                              <option value="ES">ES</option>
                                              <option value="GO">GO</option>
                                              <option value="MA">MA</option>
                                              <option value="MT">MT</option>
                                              <option value="MS">MS</option>
                                              <option value="MG">MG</option>
                                              <option value="PA">PA</option> 
                                              <option value="PB">PB</option>
                                              <option value="PR">PR</option>
                                              <option value="PE">PE</option>
                                              <option value="PI">PI</option>
                                              <option value="RJ">RJ</option>
                                              <option value="RN">RN</option>
                                              <option value="RS">RS</option>
                                              <option value="RO">RO</option>
                                              <option value="RR">RR</option>
                                              <option value="SC">SC</option>
                                              <option value="SP">SP</option>
                                              <option value="SE">SE</option>
                                              <option value="TO">TO</option>
                                          </select>
                                      </div>
                                      <div class="col-sm-4">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.city')}}
                                          </label>
                                          <input v-model="address.city" type="text" class="form-control" :placeholder="$t('string.msg.company.label.city')" />
                                      </div>
                                      <div class="form-group col-sm-4">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.street')}}
                                          </label>
                                          <input v-model="address.address" type="text" class="form-control" :placeholder="$t('string.msg.company.label.street')" />
                                      </div>
                                      <div class="form-group col-sm-2">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.number')}}
                                          </label>
                                          <input v-model="address.number" type="text" class="form-control" :placeholder="$t('string.msg.company.label.number')" />
                                      </div>
                                  </div>
                                  
                                  <div v-if="address.cep && address.cep.length == 9" class="form-row ">
                                      <div class="form-group col-sm-5">
                                          <label>
                                              <code class="highlighter-rouge">*</code>
                                              {{$t('string.msg.company.label.neighborhood')}}
                                          </label>
                                          <input v-model="address.neighborhood" type="text" class="form-control" :placeholder="$t('string.msg.company.label.neighborhood')" />
                                      </div>
                                      <div class="form-group col-sm-4">
                                          <label>
                                              {{$t('string.msg.company.label.complement')}}
                                          </label>
                                          <input v-model="address.complement" type="text" class="form-control" :placeholder="$t('string.msg.company.label.complement')" />
                                      </div>
                                  </div>

                                    </div>
                                    <form v-else-if="data.paymentType === 'BANK_SLIP'" class="mt-2">
                                      <div v-if="items && items.length > 0">


                                        <div class="form-row">
                                          <div class="form-group col-md-12 m-0">
                                            <label class="label-info m-0">
                                              {{$t('str.msg.bank.slip.monthly.desc')}}
                                            </label>
                                          </div>
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col-md-12 m-0">

                                            <div class="pb-0 pt-3 cursor-pointer">
                                                <jw-pagination :items="items" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                                            </div>
                                            <div class="table-responsive">
                                              <table class="table table-centered table-hover mb-0" id="datatable">
                                                  <thead>
                                                      <tr>
                                                          <th class="border-top-0">{{$t('string.msg.bank.slip.date')}}</th>
                                                          <th class="border-top-0">{{$t('string.msg.bank.slip.status')}}</th>
                                                          <th class="border-top-0">{{$t('string.msg.table.payment.bank.split')}}</th>
                                                      </tr>
                                                  </thead>
                                                  <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer">
                                                      <tr v-if="item">
                                                          <td>
                                                            <span v-if="item.createDate">
                                                              {{new Date(item.createDate).toLocaleDateString()}}
                                                            </span>
                                                          </td>
                                                          <td>
                                                            <span v-if="item.status">
                                                              <span v-if="item.status == 'PENDIND_PAY'" style="color: red">
                                                                <strong> {{$t('str.msg.bank.slip.pendind.pay')}}</strong>
                                                              </span>
                                                              <span v-else-if="item.status == 'PAID'" style="color: red">
                                                                <strong>{{$t('str.msg.bank.slip.pendind.pay')}}</strong>
                                                              </span>
                                                            </span>
                                                          </td>
                                                          <td>
                                                            <span v-if="item.order && item.order.paymentObject && item.order.paymentObject.boleto_url && item.status == 'PENDIND_PAY'" >
                                                              <span v-if="isCheckDate(item.order.paymentObject.due_date)" v-tooltip="$t('str.msg.download.bank.slip')">
                                                                <a target="_blank" :href="item.order.paymentObject.boleto_url"><i class="fas fa-download" style="color: black; font-size:30px"></i></a>
                                                              </span>
                                                            </span>
                                                            <span v-if="!isCheckDate(item.order.paymentObject.due_date)" v-tooltip="$t('str.msg.unavailable')">  
                                                              <i class="fas fa-ban" style="color: gray"></i>
                                                            </span>
                                                            <span v-if="item.status == 'PAID'" v-tooltip="$t('str.msg.unavailable')">  
                                                              <i class="fas fa-check" style="color: green"></i>
                                                            </span>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                              </table>
                                            </div>             
                                          </div>
                                        </div>
                                      </div>
                                      <div v-if="items.length == 0 && hasNotBankSlipInMonth" class="center cursor-pointer">
                                        <div class=" form-row">
                                          <div class="form-group col-md-12 text-center" @click="createBankSlip()">
                                            <i class="fas fa-barcode" style="font-size: 60px"></i><br>
                                            <label class="cursor-pointer m-0"><strong>{{$t('string.msg.generate.bank.slip')}} do mês de: {{$t('month-' + String(new Date().getMonth()+1)) + '/' + new Date().getFullYear() }}</strong></label>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                    
                                     <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                     </div>
                                </form>
                                <br/>
                                <div class="form-row" v-if="data.paymentType != 'BANK_SLIP'">
                                  <div class="form-group col-md-6 text-center">
                                    <button @click="clearForm" class="btn btn-secondary w-50">{{$t('string.msg.form.btn.clear')}}</button>
                                  </div>
                                  <div class="form-group col-md-6 text-center">
                                    <button @click="checkForm" class="btn btn-danger w-50">{{$t('string.msg.form.btn.save')}}</button>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtPaymentMethods';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);

export default {
  name: 'paymentMethods',
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        items: [],
        pageOfItems: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        paymentType: null,
        cardNumber: null,
        expiration: null,
        securityCode: null,
        nameOnCard: null,
        AddressCompany: null,
        generateBankSplip: true,
        hasNotBankSlipInMonth: true,
        data: {
            _id: null,
            paymentType: null,
          	number: null,
	          name: null,
	          dueDate: null,
	          cvv: null,
            isMain: null,
            document: null,
            fantasyName: null,
            documentType: null,
        },
        address: {
                state: -1,
                name: 'MAIN',
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null,
          },
          filters:{},
          customLabels: {
            first: 'Primeira',
            last: 'Último',
            previous: 'Anterior',
            next: 'Próxima'
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    state.filter();
  },
  mounted(){
  },
  computed(){
    //  $(function() {
    //   $('#cardnumber').payment('formatCardNumber');
    //   $('#cardexpiration').payment('formatCardExpiry');
    //   $('#cardcvc').payment('formatCardCVC');
      
    //   $('#cardnumber').keyup(function(event) {
    //     $('#label-cardnumber').empty().append($(this).val());
    //   });
      
    //   $('#cardexpiration').keyup(function(event) {
    //     var data = $(this).val() + '<span>' + $('#cardcvc').val() + '</span>';
    //     $('#label-cardexpiration').empty().append(data);
    //   });
      
    //   $('#cardcvc').keyup(function(event) {
    //     var data = $('#cardexpiration').val() + '<span>' + $(this).val() + '</span>';
    //     $('#label-cardexpiration').empty().append(data);
    //   });
      
    //   $('.button-cta').on('click', function () { 
    //     var proceed = true;
    //     $(".field input").each(function(){
    //       $(this).parent().find('path').each(function(){
    //         $(this).attr('fill', '#dddfe6');
    //       });
          
    //       if(!$.trim($(this).val())){
    //         $(this).parent().find('path').each(function(){
    //           $(this).attr('fill', '#f1404b');
    //           proceed = false;
    //         });
            
    //         if(!proceed){
    //           $(this).parent().find('svg').animate({opacity: '0.1'}, "slow");
    //           $(this).parent().find('svg').animate({opacity: '1'}, "slow");
    //           $(this).parent().find('svg').animate({opacity: '0.1'}, "slow");
    //           $(this).parent().find('svg').animate({opacity: '1'}, "slow");
    //         }
    //       }
    //     });
          
    //     if(proceed) //everything looks good! proceed purchase...
    //     {
    //       $('.field').find('path').each(function(){
    //         $(this).attr('fill', '#3ac569');
    //       });
    //       $('.payment').fadeToggle('slow', function() {
    //         $('.paid').fadeToggle('slow', 'linear');
    //       });
    //     }
    //   });
    // });

  }
}
</script>

<style>
</style>
